<template>
  <div>
    <div class="time">{{ currentTime }}</div>

    <div class="year">
      <div class="yyyy">{{ currentYear }}</div>
      <div class="nongli">{{ currengWeek }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return { currentTime: "", currentYear: "", currengWeek: "" };
  },
  created() {},
  mounted() {
    this.nowTimes();
  },
  methods: {
    //获取当前时间
    timeNow(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();
      let hh =
        new Date(timeStamp).getHours() < 10
          ? "0" + new Date(timeStamp).getHours()
          : new Date(timeStamp).getHours();
      let mm =
        new Date(timeStamp).getMinutes() < 10
          ? "0" + new Date(timeStamp).getMinutes()
          : new Date(timeStamp).getMinutes();
      let ss =
        new Date(timeStamp).getSeconds() < 10
          ? "0" + new Date(timeStamp).getSeconds()
          : new Date(timeStamp).getSeconds();

      this.currentTime = hh + ":" + mm + ":" + ss;
      this.currentYear = year + "/" + month + "/" + date + " ";
      this.currengWeek = "星期" + "日一二三四五六".charAt(new Date().getDay());
    },
    // 实时刷新当前时间，格式化
    nowTimes() {
      this.timeNow(new Date());
      setInterval(this.nowTimes, 1000);
      this.clear();
    },
    //清除定时器
    clear() {
      clearInterval(this.nowTimes);
      this.nowTimes = null;
    },
  },
  beforeDestroy() {
    this.clear();
  },
};
</script>

<style lang="scss" scoped>
.time {
  position: absolute;
  top: 23px;
  left: 40px;
  font-family: "barlownumber";
  font-weight: 700;
  font-size: 32px;
  line-height: 34px;
  letter-spacing: 2px;
  text-shadow: 0px 2px 2px #002853;
  text-align: center;
  font-style: normal;
  text-transform: none;
  color: #fff;
}
.year {
  position: absolute;
  top: 16px;
  right: 35px;
  width: 140px;
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.yyyy {
  font-size: 20px;
  color: #fff;
  font-family: "barlownumber";
}
.nongli {
  color: #fff;
  font-size: 14px;
}
</style>
